import { useState, useEffect } from "react";

const localStorageKey = "gfal";

const COLORS = [
  "#e57373",
  "#64b5f6",
  "#81c784",
  "#ffd54f",
  "#ba68c8",
  "#ff8a65",
  "#90a4ae",
  "#f06292",
  "#4dd0e1",
  "#aed581",
  "#fff176",
  "#a1887f",
  "#dce775",
  "#ffb300",
  "#9575cd",
  "#f44336",
  "#00bcd4",
  "#cddc39",
  "#ffeb3b",
  "#607d8b",
  "#8bc34a",
];
const ICONS = [
  "😀",
  "🐱",
  "🚀",
  "🎲",
  "👾",
  "🦄",
  "🎮",
  "🤖",
  "🧙",
  "🦊",
  "🧑‍🚀",
  "🧑‍🎤",
  "🧑‍🔬",
  "🧑‍🌾",
  "🧑‍🏫",
  "🧑‍💻",
  "🧑‍🍳",
  "🧑‍🎨",
  "🧑‍✈️",
  "🧑‍🚒",
  "🐶",
  "🐼",
  "🐧",
  "🐸",
  "🦉",
  "🦁",
  "🐯",
  "🐵",
  "🦋",
  "🐢",
  "🌟",
  "🔥",
  "⚡",
  "💎",
  "🎩",
  "🎻",
  "🎺",
  "🥁",
  "🪐",
  "🏆",
];
function getRandomUsername() {
  const ADJECTIVES = [
    "Brave",
    "Clever",
    "Swift",
    "Mighty",
    "Happy",
    "Lucky",
    "Gentle",
    "Wild",
    "Calm",
    "Bright",
    "Fierce",
    "Quiet",
    "Lively",
    "Bold",
    "Shy",
    "Witty",
    "Jolly",
    "Nimble",
    "Silly",
    "Wise",
  ];
  const NOUNS = [
    "Tiger",
    "Falcon",
    "Wizard",
    "Knight",
    "Lion",
    "Panther",
    "Fox",
    "Dragon",
    "Eagle",
    "Wolf",
    "Bear",
    "Otter",
    "Hawk",
    "Shark",
    "Dolphin",
    "Monkey",
    "Rabbit",
    "Turtle",
    "Horse",
    "Mouse",
  ];
  const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
  const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)];
  return adj + noun;
}
function getDefaultFlagCode() {
  const FLAG_CODES = [
    "us",
    "gb",
    "fr",
    "de",
    "es",
    "it",
    "jp",
    "cn",
    "in",
    "br",
    "au",
    "ca",
    "ru",
    "kr",
    "za",
    "se",
    "fi",
    "no",
    "dk",
    "nl",
    "be",
  ];
  const locale = navigator.language || navigator.userLanguage || "en-US";
  const code = (locale.split("-")[1] || "US").toLowerCase();
  return FLAG_CODES.includes(code) ? code : "us";
}
function getRandomColor() {
  return COLORS[Math.floor(Math.random() * COLORS.length)];
}
function getRandomIcon() {
  return ICONS[Math.floor(Math.random() * ICONS.length)];
}

export default function useUser() {
  const [user, setUser] = useState(() => {
    try {
      const storedRaw = localStorage.getItem(localStorageKey);
      if (storedRaw) {
        try {
          const parsed = JSON.parse(storedRaw);
          // Ensure legacy entries get a roomName field
          if (typeof parsed.roomName === "undefined") {
            parsed.roomName = "";
            try {
              localStorage.setItem(localStorageKey, JSON.stringify(parsed));
            } catch (e) {}
          }
          return parsed;
        } catch (e) {}
      }
    } catch (e) {}
    const randomUsername = getRandomUsername();
    let defaultRoomName;
    if (randomUsername.length <= 13) {
      defaultRoomName = randomUsername + "'s Room";
    } else {
      defaultRoomName = randomUsername;
    }
    const newUser = {
      username: randomUsername,
      color: getRandomColor(),
      icon: getRandomIcon(),
      flag: getDefaultFlagCode(),
      userId: null, // will be set when socket auth/userId is known
      socketId: null, // ephemeral; set when socket connects
      roomName: defaultRoomName, // default room name preference
      isFirstVisit: true, // cleared after the welcome prompt is shown
    };
    try { localStorage.setItem(localStorageKey, JSON.stringify(newUser)); } catch (e) {}
    return newUser;
  });

  useEffect(() => {
    if (user && user.username) {
      localStorage.setItem(localStorageKey, JSON.stringify(user));
    }
  }, [user]);

  return [user, setUser];
}
